module.exports = __webpack_public_path__ + "img/bg-头像@2x.487721e8.png";